// src/pages/groups/GroupFormModal.jsx
// المدرس: إنشاء/تعديل مجموعته
// الأدمن: إنشاء مجموعة جديدة مربوطة بمدرس (التعديل للمدرس بس)
import { useState } from "react";
import { groupService, getErrorMessage } from "../../services/groupService";
import { Modal } from "./groupsShared";

export default function GroupFormModal({ group, isAdmin = false, teachers = [], onClose, onSaved }) {
  const isEdit = Boolean(group);
  const needsTeacher = isAdmin && !isEdit;

  const [form, setForm] = useState({
    name: group?.name || "",
    description: group?.description || "",
    is_active: group?.is_active ?? true,
  });
  const [teacherId, setTeacherId] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const name = form.name.trim();
    if (needsTeacher && !teacherId) {
      setError("اختر المدرس المسؤول عن المجموعة");
      return;
    }
    if (!name) {
      setError("اكتب اسم المجموعة");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const payload = { name, description: form.description.trim(), is_active: form.is_active };
      let res;
      if (isEdit) {
        res = await groupService.updateGroup(group.id, payload);
      } else if (isAdmin) {
        res = await groupService.adminCreateGroup({ ...payload, teacher_id: Number(teacherId) });
      } else {
        res = await groupService.createGroup(payload);
      }
      onSaved(res.data, res.message);
    } catch (err) {
      setError(getErrorMessage(err));
      setSaving(false);
    }
  };

  return (
    <Modal
      title={isEdit ? "تعديل المجموعة" : "مجموعة جديدة"}
      onClose={onClose}
      footer={
        <>
          <button type="submit" form="gp-group-form" className="gp-btn gp-btn-primary" disabled={saving}>
            {saving ? "جاري الحفظ..." : isEdit ? "حفظ التعديلات" : "إنشاء المجموعة"}
          </button>
          <button type="button" className="gp-btn" onClick={onClose} disabled={saving}>
            إلغاء
          </button>
        </>
      }
    >
      <form id="gp-group-form" onSubmit={submit}>
        {error && <div className="gp-error">{error}</div>}

        {needsTeacher && (
          <div className="gp-field">
            <label htmlFor="gp-teacher">المدرس المسؤول</label>
            <select
              id="gp-teacher"
              className="gp-select"
              value={teacherId}
              onChange={(e) => setTeacherId(e.target.value)}
              autoFocus
            >
              <option value="">اختر المدرس</option>
              {teachers.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.full_name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="gp-field">
          <label htmlFor="gp-name">اسم المجموعة</label>
          <input
            id="gp-name"
            className="gp-input"
            value={form.name}
            onChange={set("name")}
            maxLength={150}
            autoFocus={!needsTeacher}
          />
        </div>
        <div className="gp-field">
          <label htmlFor="gp-desc">وصف المجموعة (اختياري)</label>
          <textarea id="gp-desc" className="gp-textarea" value={form.description} onChange={set("description")} />
        </div>
        <label className="gp-check">
          <input type="checkbox" checked={form.is_active} onChange={set("is_active")} />
          المجموعة نشطة (تظهر للطلبة في قائمة مجموعاتهم)
        </label>
      </form>
    </Modal>
  );
}